export default "__VITE_ASSET__D1Otrz_z__"